import React, { ChangeEvent, useRef, useState } from "react";

import { Button, Loader } from "../index";
import { UploadIcon } from "../Icons";

import styles from "./UploadExcelData.module.scss";

interface Props {
  buttonId: string;
  buttonLabel: string;
  accept?: string;
  onUpload(file: File): Promise<void>;
  onError?: (err: any) => void;
}

const NOOP_FUNC = () => {};

const UploadExcelData = (props: Props) => {
  const {
    buttonId,
    buttonLabel,
    accept = ".xlsx",
    onUpload,
    onError = NOOP_FUNC,
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const onButtonClick = () => {
    inputRef.current?.click();
  };

  const onFileSelected = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) {
      return;
    }

    setIsLoading(true);
    try {
      await onUpload(file);
    } catch (err) {
      onError(err);
    } finally {
      setIsLoading(false);
      if (event.target) {
        event.target.value = "";
      }
    }
  };

  return (
    <>
      {isLoading && <Loader className={styles.inlineLoader} fontSize={20} />}
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        onChange={onFileSelected}
        className={styles.hiddenInput}
      />
      <Button
        id={buttonId}
        variant="inline"
        disabled={isLoading}
        onClick={onButtonClick}
        className={styles.button}
        iconComponent={UploadIcon}
      >
        {buttonLabel}
      </Button>
    </>
  );
};

export default UploadExcelData;
